import { instanceV2 } from "../../../api";

const referralApi = {
    getReferralAnalytics: async (branch_id, dates = '') => {
        return await instanceV2().get(`/branches/${branch_id}/referral/analytics${dates}`)
            .then(res => res.data.data)
    },
}

export default referralApi;
